import React, { PureComponent } from 'react'
import { createSelector } from 'reselect'
import ReactDOM from 'react-dom'
import { isNull } from 'lodash'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Toolbar from 'material-ui-next/Toolbar'
import IconButton from 'material-ui-next/IconButton'
import Icon from 'material-ui-next/Icon'
import Menu, { MenuItem } from 'material-ui-next/Menu'
import withStyles from 'material-ui-next/styles/withStyles'
import { getWorlds } from '../../../selectors'
import breakpoints from '../../../styles/breakpoints'
import { isOnMobile } from '../../../utils'

const MARGIN = 10

const styles = theme => ({
  toolbar: {
    backgroundColor: '#fff',
    color: theme.swapick.colors.neutral,
    paddingLeft: `${MARGIN}px`,
    paddingRight: `${MARGIN}px`,
    minHeight: `${theme.swapick.dimensions.secondaryToolbar}px`,
    height: `${theme.swapick.dimensions.secondaryToolbar}px`,
    fontFamily: 'Roboto, sans-serif',
    fontSize: '13px',
    letterSpacing: '0.8px',
    fontWeight: '500',
  },
  toolbarGroup: {
    display: 'inline-flex',
    height: '100%',
    alignItems: 'center',
  },
  link: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '13px',
    textTransform: 'uppercase',
    letterSpacing: '0.8px',
    fontWeight: '500',
    '&:hover': {
      color: theme.swapick.colors.neutral,
    },
    '&:visited': {
      color: theme.swapick.colors.neutral,
    },
    '&:active': {
      color: theme.swapick.colors.neutral,
    },
    '&:link': {
      color: theme.swapick.colors.neutral,
    },
    [`@media (max-width: ${breakpoints.xs})`]: {
      fontSize: '11px',
    },
  },
  menuLink: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '13px',
    textTransform: 'uppercase',
    letterSpacing: '0.8px',
    fontWeight: '500',
    color: theme.swapick.colors.lightblack,
    '&:hover': {
      color: theme.swapick.colors.lightblack,
    },
    '&:visited': {
      color: theme.swapick.colors.lightblack,
    },
    '&:active': {
      color: theme.swapick.colors.lightblack,
    },
    '&:link': {
      color: theme.swapick.colors.lightblack,
    },
    [`@media (max-width: ${breakpoints.xs})`]: {
      fontSize: '11px',
    },
  },
  separator: {
    marginTop: '2px',
    fontSize: '18px',
    color: theme.swapick.colors.neutral,
    paddingRight: '10px',
    paddingLeft: '10px',
  },
  more: {
    color: theme.swapick.colors.neutral,
  },
})

class WorldsToolbar extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      lastVisibleIndex: null,
      widths: null,
      anchorEl: null,
      open: false,
      isMobile: null,
    }
    this.toolbarGroups = []
  }

  componentWillMount() {
    window.addEventListener('resize', this.resizeChildren, false)
  }

  componentDidMount() {
    this.resizeChildren()
  }

  componentDidUpdate() {
    this.resizeChildren()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeChildren)
  }

  resizeChildren = () => {
    const isMobile = isOnMobile()

    // Invalide the widths when switching between mobile / desktop
    if (!isNull(this.state.isMobile) && this.state.isMobile !== isMobile) {
      this.toolbarGroups = []
      this.setState({ widths: null, isMobile, lastVisibleIndex: null })
      return
    }

    if (this.toolbarGroups.length) {
      let widths = []
      if (!this.state.widths) {
        for (let i = 0; i < this.toolbarGroups.length; i++) {
          let groupWidth = ReactDOM.findDOMNode(
            this.toolbarGroups[i]
          ).getBoundingClientRect().width
          widths.push(groupWidth)
        }

        // Ok, relax now set state to force a re-render and fix the width!
        this.setState({ widths, isMobile })
        return
      } else {
        widths = this.state.widths
      }

      let toolbarWidth = ReactDOM.findDOMNode(
        this.toolbar
      ).getBoundingClientRect().width

      // let dotWidth = ReactDOM.findDOMNode(this.dot).getBoundingClientRect().width

      //#TODO: this should be dynamic/computed but it's very very hard
      // Remove padding
      toolbarWidth -= MARGIN * 2
      // Remove ... item
      toolbarWidth -= 48

      let lastVisibleIndex = null
      let width = 0
      for (let i = 0; i < widths.length; i++) {
        let groupWidth = widths[i]
        if (width + groupWidth < toolbarWidth) {
          width += groupWidth
        } else {
          lastVisibleIndex = i - 1
          break
        }
      }

      if (this.state.lastVisibleIndex !== lastVisibleIndex) {
        this.setState({ lastVisibleIndex, open: false, anchorEl: null })
      }
    }
  }

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget })
  }

  handleRequestClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { worlds, classes } = this.props

    const visibleWorlds = worlds.filter(
      (w, i) =>
        this.state.lastVisibleIndex == null || i <= this.state.lastVisibleIndex
    )
    const invisibleWorlds = worlds.filter(
      (w, i) =>
        this.state.lastVisibleIndex != null && i > this.state.lastVisibleIndex
    )

    // the ultimate trick
    const width = this.state.widths ? undefined : '99999px'

    return (
      <Toolbar
        style={{ width }}
        className={classes.toolbar}
        disableGutters={true}
        ref={ref => {
          this.toolbar = ref
        }}>
        {visibleWorlds.map((world, i) => {
          const isLast = i === visibleWorlds.length - 1
          return (
            <div
              className={classes.toolbarGroup}
              key={world.id}
              ref={ref => {
                this.toolbarGroups[i] = ref
              }}>
              <Link to={world.link} className={classes.link}>
                {world.nome}
              </Link>
              {!isLast && <div className={classes.separator}>{' | '}</div>}
            </div>
          )
        })}

        {invisibleWorlds.length > 0 && (
          <div className={classes.toolbarGroup}>
            <div className={classes.separator}>{' | '}</div>
            <IconButton
              classes={{ icon: classes.more }}
              aria-label="More"
              aria-owns={this.state.open ? 'more-menu' : null}
              aria-haspopup="true"
              onClick={this.handleClick}>
              <Icon>more_horiz</Icon>
            </IconButton>
            <Menu
              id="more-menu"
              anchorEl={this.state.anchorEl}
              open={this.state.open}
              onClose={this.handleRequestClose}>
              {invisibleWorlds.map(world => (
                <MenuItem
                  selected={false}
                  className={classes.menuLink}
                  to={world.link}
                  component={Link}
                  key={world.id}>
                  {world.nome}
                </MenuItem>
              ))}
            </Menu>
          </div>
        )}
      </Toolbar>
    )
  }
}

const getWorldsForToolbar = createSelector(
  getWorlds,
  worlds =>
    worlds === null || worlds.length === 0
      ? []
      : worlds
          .map(world => ({ ...world, link: `/world/${world.slug}` }))
          .concat({
            nome: 'Tutti',
            id: 'all_worlds',
            link: '/all-worlds',
          })
)

export default withStyles(styles)(
  connect(state => ({
    worlds: getWorldsForToolbar(state),
  }))(WorldsToolbar)
)



// WEBPACK FOOTER //
// ./src/common/TopBar/SecondaryToolbars/WorldsToolbar.js